module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "max-width": "750px",
      "fullscreen": ""
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.cancelEmail($event)
      }
    },
    model: {
      value: (_vm.display),
      callback: function($$v) {
        _vm.display = $$v
      },
      expression: "display"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "blue-grey"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('emailClosed')
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Email")])], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('h4', [_vm._v("Contacts")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "outline": "",
      "dismissable": "",
      "type": "error"
    },
    model: {
      value: (_vm.emailError),
      callback: function($$v) {
        _vm.emailError = $$v
      },
      expression: "emailError"
    }
  }, [_vm._v("Please enter a valid e-mail address")]), _vm._v(" "), _c('v-autocomplete', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.contactsData.data,
      "box": "",
      "hide-no-data": "",
      "chips": "",
      "label": "To:",
      "item-text": "firstName",
      "item-value": "eMail",
      "multiple": "",
      "required": "",
      "name": "email",
      "error-messages": _vm.errors.collect('email')
    },
    on: {
      "blur": function($event) {
        _vm.emailError = false
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addManualEntry($event)
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend-item",
      fn: function() {
        return [_vm._v("\n                                *Add more recipient(s) by typing e-mail address and hitting enter\n                            ")]
      },
      proxy: true
    }, {
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          staticClass: "chip--select-multi",
          attrs: {
            "selected": data.item.selected,
            "close": ""
          },
          on: {
            "input": function($event) {
              return _vm.remove(data.item)
            }
          }
        }, [_vm._v("\n                                    " + _vm._s(data.item.eMail) + "\n                                ")])]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [(typeof data !== 'object') ? [_c('v-list-tile-content', {
          domProps: {
            "textContent": _vm._s(data.item.firstName)
          }
        })] : [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(data.item.lastName) + ", " + _vm._s(data.item.firstName) + " - " + _vm._s(data.item.eMail))])], 1)]]
      }
    }]),
    model: {
      value: (_vm.contactsData.selected),
      callback: function($$v) {
        _vm.$set(_vm.contactsData, "selected", $$v)
      },
      expression: "contactsData.selected"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:5000'),
      expression: "'required|max:5000'"
    }],
    attrs: {
      "label": "Subject",
      "name": "subject",
      "counter": 5000,
      "required": "",
      "error-messages": _vm.errors.collect('subject')
    },
    model: {
      value: (_vm.subject),
      callback: function($$v) {
        _vm.subject = $$v
      },
      expression: "subject"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:8000'),
      expression: "'required|max:8000'"
    }],
    attrs: {
      "label": "Email Body",
      "name": "body",
      "required": "",
      "error-messages": _vm.errors.collect('body'),
      "counter": 8000,
      "auto-grow": ""
    },
    on: {
      "focus": _vm.setCursorPosition
    },
    model: {
      value: (_vm.body),
      callback: function($$v) {
        _vm.body = $$v
      },
      expression: "body"
    }
  })], 1), _vm._v(" "), _c('attachments', {
    attrs: {
      "attachmentType": 'email'
    },
    model: {
      value: (_vm.attachments),
      callback: function($$v) {
        _vm.attachments = $$v
      },
      expression: "attachments"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "blue-grey white--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.cancelEmail
    }
  }, [_vm._v("Cancel Email")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue-grey darken-1 white--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.submitEmail
    }
  }, [_vm._v(_vm._s(_vm.submitButton.title))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-040fb261", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-040fb261"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/src/components/email/email.vue.html
// module id = 580
// module chunks = 0